import React from "react"
import { Card, Grid, Icon } from "semantic-ui-react"
import { formatCurrency } from "uikit"
import { NavLink } from "react-router-dom"
import {
  paymentFrequencyOptions,
  PAY_FREQUENCY_DIVISOR
} from "../dropDownOptions"
import "./GenericCard.css"

const EmploymentCard = ({
  id,
  employer_name,
  type,
  ownerName,
  base_amount,
  bonus,
  pay_frequency
}) => {
  let resolvedFrequency = paymentFrequencyOptions.find(
    freq => freq.value === pay_frequency
  )
  return (
    <Card>
      <Card.Content>
        <Grid style={{ position: "relative", height: "170px" }}>
          <Grid.Row columns={2} verticalAlign="top">
            <Grid.Column>
              <NavLink
                to={`/organize/income+benefits/incomes/${id}/${type.toLowerCase()}`}
                className="navlink"
              >
                <span className="GenericCard__LinkTitle">
                  {employer_name}
                  <Icon name="chevron right" size="small" />
                </span>
              </NavLink>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <p className="GenericCard__Balance">
                {typeof base_amount === "number"
                  ? formatCurrency(
                      base_amount / PAY_FREQUENCY_DIVISOR[pay_frequency]
                    )
                  : base_amount}
              </p>
              <p className="greyed-text">
                {resolvedFrequency ? resolvedFrequency.display : ""}
              </p>
              {bonus && bonus.amount ? (
                <div>
                  <p className="GenericCard__Balance">
                    {typeof bonus.amount === "number"
                      ? formatCurrency(bonus.amount)
                      : bonus.amount}
                  </p>
                  <p className="greyed-text">
                    {new Date(2017, bonus.month - 1, 1).toLocaleString("en", {
                      month: "long"
                    }) + " Bonus"}
                  </p>
                </div>
              ) : null}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2} verticalAlign="bottom">
            <Grid.Column>
              <p className="greyed-text">{ownerName}</p>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <p className="greyed-text">Employment</p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Content>
    </Card>
  )
}

export default EmploymentCard
